<div class="bv-modal">
  <div class="bv-modal__content">
    <h3 class="bv-modal__title">{{ data.text | translate }}</h3>
    @if (data.description) {
      <p class="bv-modal__description" [innerHTML]="data.description"></p>
    }
  </div>

  <div class="bv-modal__actions">
    @if (data.type === 'info') {
      <button class="bv-modal__btn bv-modal__btn--primary" mat-dialog-close cdkFocusInitial>Aceptar</button>
    }

    @if (data.type === 'close') {
      <button class="bv-modal__btn bv-modal__btn--secondary" mat-dialog-close>{{ 'BUTTONS.CANCEL' | translate }}</button>
      <button class="bv-modal__btn bv-modal__btn--primary" [mat-dialog-close]="true" cdkFocusInitial>Salir</button>
    }

    @if (data.type === 'delete') {
      <button class="bv-modal__btn bv-modal__btn--secondary" mat-dialog-close>{{ 'BUTTONS.CANCEL' | translate }}</button>
      <button class="bv-modal__btn bv-modal__btn--danger" [mat-dialog-close]="true" cdkFocusInitial>{{ 'BUTTONS.DELETE' | translate }}</button>
    }

    @if (data.type === 'yesorno') {
      <button class="bv-modal__btn bv-modal__btn--secondary" mat-dialog-close>{{ 'TEXT.NO' | translate }}</button>
      <button class="bv-modal__btn bv-modal__btn--primary" [mat-dialog-close]="true" cdkFocusInitial>{{ 'TEXT.YES' | translate }}</button>
    }
  </div>
</div>
